import _ from "lodash"

export const getReportBrokerageAmount = report => _.get(report,['brokerage_amount','full_text'],'')
export const getReportBrokerageRate = report => _.get(report,['brokerage_rate','text'],'')
export const getReportContractReference = report => _.get(report,['contract_reference'],'')
export const getReportEntryDate =  report => _.get(report,['entry_date','text'],'')
export const getReportExchangeRate =  report => _.get(report,['exchange_rate','full_text'],'')
export const getReportForeignCharges =  report => _.get(report,['foreign_charges','full_text'],'')
export const getReportNetAmount =  report => _.get(report,['net_amount','full_text'],'')
export const getReportSSTAmount =  report => _.get(report,['sst_amount','full_text'],'')
export const getReportStampDuty =  report => _.get(report,['stamp_duty','full_text'],'')
export const getReportStockCode =  report => _.get(report,['stock_code'],'')
export const getReportStockName =  report => _.get(report,['stock_name'],'')
export const getReportTransactionDate =  report => _.get(report,['transaction_date','text'],'')
export const getReportTransactionPrice =  report => _.get(report,['transaction_price','full_text'],'')
export const getReportTransactionQuantity =  report => _.get(report,['transaction_quantity'],'')
export const getReportClearingFee =  report => _.get(report,['clearing_fee','full_text'],'')
export const getReportGrossAmount =  report => _.get(report,['gross_amount','full_text'],'')
export const getReportType =  report => _.get(report,['type'],'')
export const getReportStockCount =  report => _.get(report,['stock_count'],'')
export const getReportBrokerageAmountValue = report => _.get(report,['brokerage_amount','value'],0)
export const getReportClearingFeeValue = report => _.get(report,['clearing_fee','value'],0)
export const getReportForeignChargesValue = report => _.get(report,['foreign_charges','value'],0)
export const getReportGrossAmountValue = report => _.get(report,['gross_amount','value'],0)
export const getReportNetAmountValue = report => _.get(report,['net_amount','value'],0)
export const getReportSSTAmountValue = report => _.get(report,['sst_amount','value'],0)
export const getReportStampDutyValue = report => _.get(report,['stamp_duty','value'],0)
